module.exports = __webpack_public_path__ + "bd1692dfa88f199bf215092042ad7436.MP3";